// Logique pure d'accès au catalogue bijoux (messika-pwa#11).
// La règle de rôle reste dans computeCanSeeJewelry (source unique).
import { computeCanSeeJewelry } from '../Hooks/useCanSeeJewelry'
import type { RetailRole } from '../types'

export type CatalogDetailAccess = 'allow' | 'wait' | 'deny'

/** Garde de /catalog-detail : autorise, attend le chargement des prefs, ou refuse. */
export function catalogDetailAccess(
   retailRole: RetailRole,
   serverRetailRole: RetailRole,
   isRetailManager: boolean,
   prefsLoaded: boolean,
): CatalogDetailAccess {
   if (computeCanSeeJewelry(retailRole, serverRetailRole, isRetailManager, prefsLoaded)) return 'allow'
   return prefsLoaded ? 'deny' : 'wait'
}

/** Destination d'une recherche/filtre depuis /catalog, ou null si aucune barre n'est permise. */
export function resolveCatalogSearchTarget(
   searchScope: 'jewelry' | 'retail',
   hasJewelry: boolean,
   hasRetail: boolean,
): '/catalog-detail' | '/retail-catalog-detail' | null {
   if (searchScope === 'retail' && hasRetail) return '/retail-catalog-detail'
   if (hasJewelry) return '/catalog-detail'
   if (hasRetail) return '/retail-catalog-detail'
   return null
}
